import { useEffect, useRef, useState } from "react";
import Input from "../common/Input";
import useSendMessage from "#features/Chat/hooks/agent/useSendMessage";
import { useConnectionState } from "../../hooks/communication/useReconnectionHandler";

const CustomInput = () => {
  const inputRef = useRef(null);
  const { sendUserMessage, currentChannel } = useSendMessage();
  const { isInputEnabled, isReconnecting, isSyncing } = useConnectionState();
  const canInput = isInputEnabled && !isSyncing;
  const [isTyping, setIsTyping] = useState(false);

  const search = async () => {
    if (!canInput) {
      return;
    }

    const message = inputRef.current.value.trim();
    if (message) {
      const msg = message;
      inputRef.current.value = "";
      await sendUserMessage({ message: msg });
      if (currentChannel) {
        currentChannel.endTyping(); // 메시지를 전송하면 타이핑 끝 알림을 보냄
        inputRef.current.focus();
      }
      setIsTyping(false);
    }
  };

  const onKeyUp = async (e) => {
    if (!canInput) {
      return;
    }

    if (e.key === "Enter" || e.keyCode === 13) {
      search();
      inputRef.current.focus();
    }
  };

  const onKeyDown = async (e) => {
    if (!canInput) {
      return;
    }

    if (!isTyping && currentChannel) {
      currentChannel.startTyping(); // 타이핑 시작
      setIsTyping(true);
    }
  };

  useEffect(() => {
    let typingTimeout;

    if (isTyping) {
      typingTimeout = setTimeout(() => {
        if (currentChannel) {
          currentChannel.endTyping(); // 일정 시간 타이핑이 없으면 타이핑 끝 알림을 보냄
        }
        setIsTyping(false);
      }, 3000); // 3초 후 타이핑 끝 알림
    }

    return () => {
      clearTimeout(typingTimeout);
    };
  }, [isTyping, currentChannel]);

  useEffect(() => {
    if (!canInput && isTyping && currentChannel) {
      currentChannel.endTyping();
      setIsTyping(false);
    }
  }, [canInput, isTyping, currentChannel]);

  const onSendButtonClick = async () => {
    search();
    inputRef.current.blur();
  };

  return (
    <Input
      onKeyDown={onKeyDown}
      onKeyUp={onKeyUp}
      onSendButtonClick={onSendButtonClick}
      inputRef={inputRef}
      disabled={!canInput}
      placeholder={
        !canInput
          ? isSyncing
            ? "상담 상태 확인 중입니다"
            : isReconnecting
              ? "지금은 메시지 전송이 불가능합니다"
              : "연결 대기 중입니다"
          : "궁금한 사항을 입력해 주세요"
      }
    />
  );
};

export default CustomInput;
